import { gql } from '@apollo/client';

export const GET_ACTIVITY = gql`
  query GetActivity($id: ID!) {
    activity: getActivity(id: $id) {
      id
      activityTargets {
        id
        endDate
        groupingType
        numberOfSessions
        expectedNumberOfAttendees
        plannedDuration
        startDate
        cohort {
          id
          name
        }
        frequency {
          id
          name
        }
        frequencyType {
          id
          name
        }
        institution {
          id
          name
        }
      }
      archivedSessionAttendees {
        id
      }
      caseManagement
      requiresReview
      flagReview
      attendeeCount
      audienceSize {
        id
        name
      }
      audienceType {
        id
        name
      }
      groupInstitutions {
        id
        name
      }
      groupCohorts {
        id
        name
      }
      inputTypes {
        id
        name
        quantity {
          quantity
        }
      }
      inputs {
        id
        description
        quantity
        type {
          id
          name
        }
      }
      interfaceType {
        id
        name
      }
      intervention {
        id
        name
        fromDate
        toDate
      }
      interventions {
        id
        name
        fromDate
        toDate
      }
      institutions {
        id
        name
      }
      cohorts {
        id
        name
      }
      name
      numberOfAttendees
      renderGroupForm
      multiDay
      weeklyTracking
      sunday
      monday
      tuesday
      wednesday
      thursday
      friday
      saturday
      historicalData
      weekStartDay
      numberOfDaysPerWeek
      totalExpectedAttendeesForSessionBasedActivity
      totalGroupFormAttendees
      sessionBasedAttendees
      numberOfDays
      sessionAttendees {
        id
      }
      sessions {
        id
      }
      tags {
        name
      }
      targetAudiences {
        id
        name
      }
      targetGroup {
        id
        name
      }
      totalNumberOfSessions
      trackingLevel
      groupingType
      type {
        id
        name
      }
      stakeholderTypes {
        id
        name
      }
      programme {
        id
        name
        fromDate
        toDate
      }
      sites {
        id
        name
        startDate
        endDate
      }
      services {
        id
        name
        startDate
        endDate
        categories {
          id
          name
        }
      }
    }
  }
`;
